"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CLIENT_ID = exports.DEFAULT_REALM = void 0;
exports.DEFAULT_REALM = 'aerogear';
exports.DEFAULT_CLIENT_ID = 'unified-push-server-js';
//# sourceMappingURL=index.js.map